export default __webpack_public_path__ + "static/gameplay-e0d420a478c7f4f8bb65529f7bb1a2d3.png";